import { axiosInstance } from "./config";

export default {
  state: {
    distance_unit: {},
  },
  mutations: {
    Set_distance_unit(state, payload) {
      state.distance_unit = payload;
    },
  },
  actions: {
    async Get_distance_unit({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/distance_unit${payload}`)
        .then(function (data) {
          commit("Set_distance_unit", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_distance_unit(commit, payload) {
      return await axiosInstance
        .post("/distance_unit", payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Put_distance_unit(commit, payload) {
      return await axiosInstance
        .put("/distance_unit/" + payload.id, payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Delete_distance_unit(commit, payload) {
      return await axiosInstance
        .put("/distance_unit/" + payload.id)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
  },
  getters: {
    g_distance_unit: (state) => state.distance_unit,
  },
};
